import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  currentDateSingle,
  formatIndianCurrency,
  scrollToTop,
} from "../../../../utils/utils";
import Flatpickr from "react-flatpickr";
import PageMetaData from "../../../PageMetaData/PageMetaData";
import NewUiHeader from "../../NewUIHeader/NewUIHeader";
import SinglectivityModifyHeader from "../../../SinglePackageHeader/SingleActivityModifyHeader";
import Skeleton from "react-loading-skeleton";
import { Fancybox } from "@fancyapps/ui";
import imgNotFound from "../../../../assets/images/single-image.png";
import OurQuery from "../../../OurQuery/OurQuery";
import ChooseUs from "../../../ChooseUs/ChooseUs";
import ActivityQueryFormPopup from "../../../NewSendEnquiryPopup/ActivityQueryFormPopup";
import NewFooterUI from "../../NewFooterUI/NewFooterUI";
import styles from "./SingleActivity.module.scss";
import {
  SvgDownload,
  SvgEmail,
  SvgPrint,
  SvgWhatsapp,
} from "../../../../utils/svgIcons";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import EditNewUiSearchFormActivity from "../../NewUiSearchForm/NewUiSearchFormActivity/EditNewUiSearchFormActivity";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} arrowRight slideArrows`}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} arrowLeft slideArrows`}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function SingleActivity() {
  const [singleActivityData, setSingleActivityData] = useState({});
  const location = useLocation();
  const [bookingData, setBookingData] = useState({});
  const [activeIndex, setActiveIndex] = useState(null);
  const [loader, setLoader] = useState(true);
  const [bookngDate, setBookingDate] = useState(currentDateSingle);
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [markupData, setMarkupData] = useState([]);
  const [commission, setCommission] = useState({});
  const userType = localStorage.getItem("userType");
  const [filter, setFilter] = useState("overview");
  const [detailedFilter, setDetailedFilter] = useState("terms_and_conditions");
  const userToken = localStorage.getItem("token");
  const navigate = useNavigate();
  const [modifyPkg, setModiyPkg] = useState(false);
  const toggleModify = () => {
    setModiyPkg(!modifyPkg);
  };
  const [startDate, setStartDate] = useState(currentDateSingle);
  const [endDate, setEndDate] = useState("");
  const [guest, setGuest] = useState(1);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);
  const [childAge, setChildAge] = useState([]);
  const { slug } = useParams();
  const { id } = useParams();
  const [showRatePopup, setshowRatePopup] = useState(false);
  const handleDetailedFilter = (value) => {
    setDetailedFilter(value);
  };
  const handleshowRatePopup = (e) => {
    e.stopPropagation();
    setshowRatePopup(!showRatePopup);
  };

  const [guestDetails, setIsguestDetails] = useState(false);
  const dropdownGuestDetails = () => {
    setIsguestDetails(!guestDetails);
  };
  const [formData, setFormData] = useState({
    company_name: "",
    name: "",
    phone: "",
    email: "",
    querry_detail: "",
    country: "",
    state: "",
    city: "",
    address: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const fetchSingleActivityData = () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);

    // Set loader to true when the request starts
    setLoader(true);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/activities/fetch/single/${slug}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setSingleActivityData(result?.data);
        // Set loader to false when the data is fetched successfully
        scrollToTop();
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        // Set loader to false in case of an error
        setLoader(false);
      });
  };

  useEffect(() => {
    fetchSingleActivityData();
  }, []);

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);

  //   const data = {
  //     location: params.get("location"),
  //     adult: params.get("adult") || 1,
  //     date: params.get("date"),
  //     month: params.get("month"),
  //     year: params.get("year"),
  //   };

  //   const bookingDate = `${data.year}-${String(data.month).padStart(
  //     2,
  //     "0"
  //   )}-${String(data.date).padStart(2, "0")}`;

  //   if (data.date && data.month && data.year) {
  //     setBookingDate(bookingDate);
  //   } else {
  //     setBookingDate(currentDateSingle);
  //   }
  //   setBookingData({ ...data, bookingDate });
  // }, [location.search]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const data = {
      location: params.get("location"),
      adult: params.get("adult"),
      date: params.get("date"),
      month: params.get("month"),
      year: params.get("year"),
    };

    const checkInDate = `${data.year}-${String(data.month).padStart(
      2,
      "0"
    )}-${String(data.date).padStart(2, "0")}`;

    const bookingDate = `${data.year}-${String(data.month).padStart(
      2,
      "0"
    )}-${String(data.date).padStart(2, "0")}`;

    // const checkOutDate = `${data.checkoutYear}-${String(
    //     data.checkoutMonth
    // ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    // setGuest(data.guest);
    // setChildren(data.children ? data.children : 0);
    // setRooms(data.room);
    // setChildAge(childAges);

    if (data.date && data.month && data.year) {
      setStartDate(checkInDate);
    } else {
      setStartDate(currentDateSingle);
    }
    setBookingData({ ...data, bookingDate });
  }, [location.search]);

  const settings = {
    dots: false,
    infinite: singleActivityData?.activityImages > 1,
    speed: 500,
    slidesToShow: Math.min(singleActivityData?.activityImages, 3),
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const slider = React.useRef(null);

  const totalAddonsCostWithoutCommission = selectedAddOns?.reduce(
    (total, addon) => {
      if (addon.addonPriceWithMarkup) {
        if (addon.perPerson && bookingData?.adult) {
          return (
            total +
            Number(addon.addonPriceWithMarkup) * Number(bookingData?.adult)
          );
        } else {
          return total + Number(addon.addonPriceWithMarkup);
        }
      }
    },
    0
  );

  const totalAddonsCost = selectedAddOns.reduce((total, addon) => {
    if (addon.perPerson && bookingData?.adult) {
      return total + Number(addon.finalAddonPrice) * Number(bookingData.adult);
    } else {
      return total + Number(addon.finalAddonPrice);
    }
  }, 0);

  const navigateToCheckOutActivity = () => {
    navigate(
      `/checkout-activities/${singleActivityData?.activityHandle}&guest=${bookingData?.adult}`,
      {
        state: {
          activityData: singleActivityData,
          bookingData: bookingData,
          activityPrice: displayedRate,
          selectedAddOns: selectedAddOns,
          totalAddonsCost: totalAddonsCost,
          totalAddonsCostWithoutCommission: totalAddonsCostWithoutCommission,
          markupData: markupData,
          activityPriceWithMarkup,
          activityPriceWithMarkup,
        },
      }
    );
  };

  const [displayedRate, setDisplayedRate] = useState(null);
  const [activityPriceWithMarkup, setActivityPriceWithmarkup] = useState(null);

  const [agentSavingsonAddons, setAgentSavingsonAddons] = useState(null);

  const filterRatesByAdults = (activityRates, numberOfAdults) => {
    if (!activityRates || activityRates.length === 0) return null;
    const adults = parseInt(numberOfAdults, 10);
    const matchingRate = activityRates.find((rate) => rate.pax === adults);
    return matchingRate ? matchingRate.amount : null;
  };

  const handleSelectedAddOns = (addon) => {
    setSelectedAddOns((prevSelected) => {
      const isSelected = prevSelected.some(
        (selected) => selected.id === addon.id
      );
      if (isSelected) {
        return prevSelected.filter((selected) => selected.id !== addon.id);
      } else {
        return [...prevSelected, addon];
      }
    });
  };

  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const toggleAccordionPolicies = (index) => {
    if (expandedIndex === index) {
      setExpandedIndex(null);
    } else {
      setExpandedIndex(index);
    }
  };

  // markup fetch api
  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          if (findObject) {
            setMarkupData(findObject);
          } else {
            setMarkupData(null);
          }
        }
      })
      .catch((error) => console.error(error));
  };

  const fetchCommissions = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: urlencoded,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/commission/activity/${singleActivityData?.activityId}`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        if (
          data?.data?.commissionType != "none" &&
          data?.data?.commissionAmount !== 0
        ) {
          setCommission(data?.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (singleActivityData?.activityId && userType === "agent") {
      fetchCommissions();
    }
  }, [singleActivityData?.activityId, userType]);

  useEffect(() => {
    fetchMarkup();
  }, []);

  useEffect(() => {
    const adultCount = bookingData?.adult ?? 1;

    if (singleActivityData?.activityRates && adultCount) {
      const rate = filterRatesByAdults(
        singleActivityData.activityRates,
        adultCount
      );

      if (rate === null) {
        setDisplayedRate(null);
        return;
      }

      let finalRate = rate;
      let activityRateWithMarkup = rate;

      if (markupData) {
        const markup = markupData;
        if (markup.markupType === "percentage") {
          finalRate += (rate * parseFloat(markup.amount)) / 100;
        } else {
          finalRate += parseFloat(markup.amount);
        }
      }

      activityRateWithMarkup = finalRate;

      // if (commission?.commissionAmount && commission?.commissionType) {
      //   if (commission?.commissionType === "percentage") {
      //     finalRate -=
      //       (Number(finalRate) * Number(commission?.commissionAmount)) / 100;
      //   } else if (commission?.commissionType === "fixed") {
      //     finalRate = Number(commission?.commissionAmount);
      //   }
      // }
      // const savings = activityRateWithMarkup - finalRate;
      setDisplayedRate(finalRate);
      setActivityPriceWithmarkup(activityRateWithMarkup);
      // setAgentSavingsonActivity(savings);
    }
  }, [singleActivityData, bookingData, commission, markupData]);

  function calculatePriceWithCommission(amount, commissionData) {
    if (!commissionData || Object.keys(commissionData).length === 0) {
      return amount;
    }

    let { commissionAmount, commissionType } = commissionData;

    if (!commissionAmount || !commissionType) {
      return amount;
    }

    commissionAmount = parseFloat(commissionAmount);

    if (commissionType === "percentage") {
      return amount - (amount * commissionAmount) / 100;
    } else if (commissionType === "fixed") {
      return amount - commissionAmount;
    } else {
      console.warn("Invalid commission type:", commissionType);
      return amount;
    }
  }

  const detailedItinerary = [
    { label: "Terms & Conditions", value: "terms_and_conditions" },
    { label: "Cancellation Policy", value: "cancellation_policy" },
  ];
  const mainFilters = [
    { label: "overview", value: "overview" },
    { label: "Inclusions & Exclusions", value: "inclusion_exclusion" },
    { label: "Points To Remember", value: "points_to_remember" },
    { label: "Terms & Conditions", value: "terms_and_conditions" },
    { label: "Cancellation Policy", value: "cancellation_policy" },
    { label: "FAQs", value: "faq" },
  ];
  const [activeFilter, setActiveFilter] = useState("overview");
  const [showAllTabs, setShowAllTabs] = useState(false);

  const handleTabClick = (value) => {
    if (value === "overview") {
      setShowAllTabs(!showAllTabs); // Toggle visibility of other tabs
    }
    setActiveFilter(value);
  };
  // Filter Scroll Section
  // const handleScrollToSection = (sectionValue) => {
  //   setFilter(sectionValue);
  //   document
  //     .getElementById(sectionValue)
  //     ?.scrollIntoView({ behavior: "smooth" });
  // };
  
  const [openOuterAccordion, setOpenOuterAccordion] = useState(["overview"]);
  const handleScrollToSection = (sectionValue) => {
    setFilter(sectionValue);

    setOpenOuterAccordion([sectionValue]);

    const section = document.getElementById(sectionValue);
    if (section) {
      const sectionPosition =
        section.getBoundingClientRect().top + window.scrollY;
      const sectionHeight = section.offsetHeight;
      const windowHeight = window.innerHeight;

      const scrollTo = sectionPosition - windowHeight / 3 + sectionHeight / 3;

      window.scrollTo({
        top: scrollTo,
        behavior: "smooth",
      });
    }

    setShowAllTabs(false);
    setOpenOuterAccordion([sectionValue]);
  };

  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }

    try {
      await navigate(
        `/single-activity/${singleActivityData?.activityHandle}?${
          singleActivityData?.activityId
        }&adult=${guest}&date=${new Date(startDate).getDate()}&month=${
          new Date(startDate).getMonth() + 1
        }&year=${new Date(startDate).getFullYear()}`,
        undefined,
        { shallow: false }
      );

      setModiyPkg(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      // Click is outside the dropdown, so close it
      // setIsguestDetails(false);
    }
  };
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (id) => {
    setOpenSection(openSection === id ? null : id);
  };
  const [openTabs, setOpenTabs] = useState(["priceBreakup"]);

  const toggleTab = (tab) => {
    setOpenTabs((prev) =>
      prev.includes(tab) ? prev.filter((t) => t !== tab) : [...prev, tab]
    );
  };

  return (
    <div>
      {/* <PageMetaData
        title="Mountain Mysteries"
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      /> */}
      <PageMetaData
        title={`${
          singleActivityData?.metaData?.metaTitle
            ? singleActivityData.metaData.metaTitle
            : singleActivityData?.activityName || ""
        } `}
        description={
          singleActivityData?.metaData?.metaDescription
            ? singleActivityData.metaData.metaDescription
            : ""
        }
        keywords={
          singleActivityData?.metaData?.metaKeywords
            ? singleActivityData.metaData.metaKeywords
            : ""
        }
      />
      <NewUiHeader />{" "}
      <EditNewUiSearchFormActivity
        searchType="single_activity"
        setSelectedAddOns={setSelectedAddOns}
      />
      <div className={styles.section_with_background}>
        <div className="container">
          <section className={styles.gallery_sec_bg}>
            {/* Package Destinations */}
            <div className={styles.all_destinations_wrapper}>
              {singleActivityData?.activityName &&
                singleActivityData?.activityName !== "null" && (
                  <div className={styles.all_destinations_card}>
                    <h4 className="text-capitalize">
                      {" "}
                      {singleActivityData.activityName}
                    </h4>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_5983_7301"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="20"
                      >
                        <rect width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_5983_7301)">
                        <path
                          d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                          fill="#888888"
                        />
                      </g>
                    </svg>
                    <span>{singleActivityData.activityDestination}</span>
                  </div>
                )}

              {/* Download / Share / Mail / Print */}
              {/* <button onClick={toggleModify} className={styles.modify_btn}>
                Modify
              </button> */}

              {modifyPkg && (
                <div className="ScreenDimmer">
                  <div className="container Single_pkg_header-modify">
                    <button
                      className="Single_pkg_header-close"
                      onClick={() => [toggleModify(false)]}
                      style={{ background: "#EB442D" }}
                    >
                      X
                    </button>
                    <div className="Single_pkg_header-modify_main">
                      <h2 style={{ textAlign: "center", marginBottom: "15px" }}>
                        Modify
                      </h2>
                      <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="flex_align_center Single_pkg_header-resp Single_pkg_header-modify_head">
                          <div className="flex_align_center Single_pkg_header-resp-cards Single_pkg_header-resp-cards_content">
                            <div className="Single_pkg_header-cards  Single_pkg_header-modify_cards border-right-one ">
                              <div className="Single_pkg_header-form_content Single_pkg_header-input ">
                                <label htmlFor="">Departure Date</label>

                                {/* <Flatpickr
                                  className="w-full"
                                  // type="date"
                                  value={
                                    startDate ? startDate : currentDateSingle
                                  }
                                  onChange={([date]) => setStartDate(date)}
                                /> */}
                                <div
                                  className={`new_date_picker_react_js_custom_styling activity_modidy_date_wrapper`}
                                >
                                  <DatePicker
                                    selected={
                                      startDate ? startDate : currentDateSingle
                                    }
                                    onChange={(date) => setStartDate(date)}
                                    portalId="root-portal NewUIReactDatePicker"
                                    popperPlacement="bottom-start"
                                    minDate={new Date()}
                                    dateFormat="dd MMM, yyyy"
                                    placeholderText={
                                      startDate
                                        ? format(startDate, "dd MMM, yyyy")
                                        : "Travel Date"
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              className="Single_pkg_header-cards Single_pkg_header-modify_cards"
                              style={{ padding: "0 30px 0 15px" }}
                            >
                              <label htmlFor="">Guests</label>
                              <p
                                style={{ position: "relative" }}
                                className="Single_pkg_header-input SingleSearch-Guests dropdown-toggle  "
                              >
                                <div
                                  style={{ margin: "5px 0" }}
                                  onClick={dropdownGuestDetails}
                                  ref={dropdownRef}
                                >
                                  <div className="optionCounter"></div>
                                  <span
                                    className="Single_pkg_header-guest_details"
                                    style={{ fontWeight: "700" }}
                                    id="adult_count"
                                  >
                                    {guest}
                                  </span>
                                  <span className="Single_pkg_header-guest_details">
                                    {" "}
                                    Guests,
                                  </span>{" "}
                                </div>
                                {guestDetails && (
                                  <div
                                    className="guest_details_dropdown"
                                    id="guestDetailsPopup"
                                  >
                                    <div className="agent">
                                      <span>Guests</span>
                                      <div className="flex align_items_center">
                                        <button
                                          type="button"
                                          disabled={guest <= 1}
                                          className="optionCounterButton optionCounterButtonWithBorder"
                                          onClick={() => {
                                            if (Number(guest) <= 1) return;
                                            setGuest(Number(guest) - 1);
                                          }}
                                        >
                                          <span
                                            className="onclick_btn"
                                            id="adult_minus"
                                          >
                                            -
                                          </span>
                                        </button>

                                        <input
                                          className="optionCounterNumber"
                                          value={guest}
                                          min={1}
                                        />

                                        <button
                                          type="button"
                                          // disabled={rooms <= 1}
                                          className="optionCounterButton optionCounterButtonWithBorder"
                                          onClick={() =>
                                            setGuest(Number(guest) + 1)
                                          }
                                        >
                                          <span
                                            className="onclick_btn"
                                            id="adult_plus"
                                          >
                                            +
                                          </span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </p>
                            </div>
                          </div>
                          <div
                            className="Single_pkg_header-cards  Single_pkg_header-resp-cards"
                            style={{ textAlign: "center" }}
                          >
                            <button
                              className="Single_pkg_header_apply"
                              style={{ background: "#EB442D" }}
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>{" "}
            {loader ? (
              <>
                {Array.from({ length: 1 }).map((_, index) => (
                  <div className="gallery" key={index}>
                    <div>
                      <Skeleton height={350} />
                    </div>
                    <div className="gallery2">
                      <div>
                        <Skeleton height={170} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={170} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={170} />
                      </div>
                      <div className="SingleHotel-gallary-sm">
                        <Skeleton height={170} />
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="relative mt-10">
                {singleActivityData?.activityImages &&
                  singleActivityData?.activityImages.length > 0 && (
                    <>
                      <div className={styles.gallery}>
                        <div className={styles.gallery1}>
                          {singleActivityData?.activityImages?.length > 0 ? (
                            <img
                              src={singleActivityData.activityImages[0]}
                              alt="hotel-image"
                            />
                          ) : (
                            <img src={imgNotFound} alt="Image not found" />
                          )}
                          {singleActivityData?.activityImages?.length > 1 && (
                            <div>
                              <button
                                className="see_all_images"
                                onClick={() => {
                                  Fancybox.show(
                                    singleActivityData?.activityImages?.map(
                                      (src) => ({
                                        src,
                                        type: "image",
                                      })
                                    )
                                  );
                                }}
                              >
                                <svg
                                  width="15"
                                  height="15"
                                  viewBox="0 0 16 15"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M8 11.625C8.9375 11.625 9.73438 11.2969 10.3906 10.6406C11.0469 9.98438 11.375 9.1875 11.375 8.25C11.375 7.3125 11.0469 6.51562 10.3906 5.85938C9.73438 5.20312 8.9375 4.875 8 4.875C7.0625 4.875 6.26562 5.20312 5.60938 5.85938C4.95312 6.51562 4.625 7.3125 4.625 8.25C4.625 9.1875 4.95312 9.98438 5.60938 10.6406C6.26562 11.2969 7.0625 11.625 8 11.625ZM8 10.125C7.475 10.125 7.03125 9.94375 6.66875 9.58125C6.30625 9.21875 6.125 8.775 6.125 8.25C6.125 7.725 6.30625 7.28125 6.66875 6.91875C7.03125 6.55625 7.475 6.375 8 6.375C8.525 6.375 8.96875 6.55625 9.33125 6.91875C9.69375 7.28125 9.875 7.725 9.875 8.25C9.875 8.775 9.69375 9.21875 9.33125 9.58125C8.96875 9.94375 8.525 10.125 8 10.125ZM2 14.25C1.5875 14.25 1.23438 14.1031 0.940625 13.8094C0.646875 13.5156 0.5 13.1625 0.5 12.75V3.75C0.5 3.3375 0.646875 2.98438 0.940625 2.69063C1.23438 2.39688 1.5875 2.25 2 2.25H4.3625L5.75 0.75H10.25L11.6375 2.25H14C14.4125 2.25 14.7656 2.39688 15.0594 2.69063C15.3531 2.98438 15.5 3.3375 15.5 3.75V12.75C15.5 13.1625 15.3531 13.5156 15.0594 13.8094C14.7656 14.1031 14.4125 14.25 14 14.25H2ZM2 12.75H14V3.75H10.9625L9.59375 2.25H6.40625L5.0375 3.75H2V12.75Z" />
                                </svg>
                                See all images
                              </button>
                            </div>
                          )}
                        </div>
                        <div className={styles.gallery2}>
                          <div>
                            {singleActivityData?.activityImages?.length > 1 ? (
                              <img
                                src={singleActivityData.activityImages[1]}
                                alt="hotel-image"
                              />
                            ) : (
                              <img src={imgNotFound} alt="Image not found" />
                            )}
                          </div>
                          <div className="SingleHotel-gallary-sm">
                            {singleActivityData?.activityImages?.length > 1 ? (
                              <img
                                src={singleActivityData.activityImages[2]}
                                alt="hotel-image"
                              />
                            ) : (
                              <img src={imgNotFound} alt="Image not found" />
                            )}
                          </div>
                        </div>
                        <div className={styles.gallery3}>
                          <div className="SingleHotel-gallary-sm">
                            {singleActivityData?.activityImages?.length > 1 ? (
                              <img
                                src={singleActivityData.activityImages[3]}
                                alt="hotel-image"
                              />
                            ) : (
                              <img src={imgNotFound} alt="Image not found" />
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            )}
          </section>
        </div>
        {/* Filter Section */}
        <div className={`${styles.filter_section}`}>
          <div className={styles.container}>
            <div className={styles.filter_wrapper}>
              {mainFilters.map((item, index) => (
                <div
                  key={index}
                  onClick={() => handleScrollToSection(item.value)}
                  className={`${styles.filter_card} ${
                    filter === item.value ? styles.active_filter : ""
                  }`}
                >
                  {item.label}
                </div>
              ))}{" "}
            </div>
            <div className={styles.mobile_filter_wrapper}>
              <div
                onClick={() => handleTabClick("overview")}
                className={`${
                  styles.filter_card
                } flex align_items_center justify_content_center flex_gap_5 ${
                  activeFilter === "overview" ? styles.active_filter : ""
                }`}
              >
                Overview{" "}
                <svg
                  width="11"
                  height="8"
                  viewBox="0 0 13 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    transition: "transform 0.4s",
                    transform: showAllTabs ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                >
                  <path
                    d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                    stroke="#009A50"
                    strokeWidth="1.5"
                  />
                </svg>
              </div>
              {showAllTabs &&
                mainFilters
                  .filter((item) => item.value !== "overview")
                  .map((item, index) => (
                    <div
                      key={index}
                      onClick={() => handleScrollToSection(item.value)}
                      className={`${styles.filter_card} ${
                        activeFilter === item.value ? styles.active_filter : ""
                      }`}
                    >
                      {item.label}{" "}
                    </div>
                  ))}
            </div>
          </div>
        </div>
        {/* Activities Details */}
        <section>
          <div className="container">
            <div className={styles.main_flex}>
              <div className={styles.overview_content} id="overview">
                <div>
                  {/* Overview */}
                  {singleActivityData?.activityDescription?.length > 0 && (
                    <div className={styles.accord_heading_overview}>
                      <div
                        className={styles.accord_flex}
                        onClick={() =>
                          setOpenOuterAccordion((prev) => {
                            if (prev.includes("overview")) {
                              return prev.filter((item) => item !== "overview");
                            } else {
                              return [...prev, "overview"];
                            }
                          })
                        }
                      >
                        <h4>Overview</h4>
                        <svg
                          className={`${styles.accordion_icon} ${
                            openOuterAccordion.includes("overview")
                              ? styles.active
                              : ""
                          }`}
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_6802_2306"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                          >
                            <rect
                              y="24"
                              width="24"
                              height="24"
                              transform="rotate(-90 0 24)"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_6802_2306)">
                            <path
                              d="M11.9993 14.815L19.532 7.28227C19.7307 7.08361 19.9646 6.98677 20.2338 6.99177C20.5031 6.99694 20.7371 7.09885 20.9358 7.29752C21.1344 7.49635 21.2338 7.73035 21.2338 7.99952C21.2338 8.26869 21.1344 8.50269 20.9358 8.70152L13.28 16.3725C13.0992 16.5534 12.8966 16.6874 12.6723 16.7745C12.4479 16.8617 12.2236 16.9053 11.9993 16.9053C11.7749 16.9053 11.5506 16.8617 11.3263 16.7745C11.1019 16.6874 10.8994 16.5534 10.7185 16.3725L3.04728 8.70152C2.84862 8.50269 2.75187 8.26611 2.75703 7.99177C2.7622 7.71744 2.86412 7.48094 3.06278 7.28227C3.26145 7.08361 3.49545 6.98427 3.76478 6.98427C4.03395 6.98427 4.26787 7.08361 4.46653 7.28227L11.9993 14.815Z"
                              fill="#1C1B1F"
                            />
                          </g>
                        </svg>
                      </div>
                      {openOuterAccordion.includes("overview") && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: singleActivityData?.activityDescription,
                          }}
                        ></div>
                      )}
                    </div>
                  )}

                  {/* Inclusions/Exclusions */}
                  {singleActivityData?.activityLegals?.length > 0 && (
                    <div
                      className={styles.accord_heading}
                      id="inclusion_exclusion"
                    >
                      <div
                        className={`${styles.left_wrapper_inner} ${styles.inclusion_exclusion}`}
                      >
                        <div
                          className={styles.accord_flex}
                          onClick={() =>
                            setOpenOuterAccordion((prev) => {
                              if (prev.includes("inclusion_exclusion")) {
                                return prev.filter(
                                  (item) => item !== "inclusion_exclusion"
                                );
                              } else {
                                return [...prev, "inclusion_exclusion"];
                              }
                            })
                          }
                        >
                          <h4>Inclusions/Exclusions</h4>
                          <svg
                            style={{
                              transform: openOuterAccordion.includes(
                                "inclusion_exclusion"
                              )
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "0.3s ease-in-out",
                            }}
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_6802_2306"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="24"
                              height="24"
                            >
                              <rect
                                y="24"
                                width="24"
                                height="24"
                                transform="rotate(-90 0 24)"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_6802_2306)">
                              <path
                                d="M11.9993 14.815L19.532 7.28227C19.7307 7.08361 19.9646 6.98677 20.2338 6.99177C20.5031 6.99694 20.7371 7.09885 20.9358 7.29752C21.1344 7.49635 21.2338 7.73035 21.2338 7.99952C21.2338 8.26869 21.1344 8.50269 20.9358 8.70152L13.28 16.3725C13.0992 16.5534 12.8966 16.6874 12.6723 16.7745C12.4479 16.8617 12.2236 16.9053 11.9993 16.9053C11.7749 16.9053 11.5506 16.8617 11.3263 16.7745C11.1019 16.6874 10.8994 16.5534 10.7185 16.3725L3.04728 8.70152C2.84862 8.50269 2.75187 8.26611 2.75703 7.99177C2.7622 7.71744 2.86412 7.48094 3.06278 7.28227C3.26145 7.08361 3.49545 6.98427 3.76478 6.98427C4.03395 6.98427 4.26787 7.08361 4.46653 7.28227L11.9993 14.815Z"
                                fill="#1C1B1F"
                              />
                            </g>
                          </svg>
                        </div>
                        <div className={styles.inclusion_exclusion_content}>
                          {openOuterAccordion.includes(
                            "inclusion_exclusion"
                          ) && (
                            <div className={styles.inclusion_content}>
                              <h4>Inclusion</h4>
                              {singleActivityData?.activityLegals
                                ?.filter((item) => item.type === "inclusion")
                                .map((item, index) => (
                                  <div
                                    key={index}
                                    className={`${styles.inner_common_content} ${styles.inclusion_inner_content}`}
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  ></div>
                                ))}
                            </div>
                          )}
                          {openOuterAccordion.includes(
                            "inclusion_exclusion"
                          ) && (
                            <div className={styles.exclusion_content}>
                              <h4>Exculsion</h4>
                              {singleActivityData?.activityLegals
                                ?.filter((item) => item.type === "exclusion")
                                .map((item, index) => (
                                  <div
                                    key={index}
                                    className={`${styles.inner_common_content} ${styles.inclusion_inner_content}`}
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  ></div>
                                ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Policies */}
                    {singleActivityData?.activityLegals?.filter(
                      (item) => item.type === "terms_and_conditions"
                    )?.length > 0 && (
                    <div
                      className={styles.accord_heading}
                      id="terms_and_conditions"
                    >
                      <div
                        className={styles.accord_flex}
                        onClick={() =>
                          setOpenOuterAccordion((prev) => {
                            if (prev.includes("terms_and_conditions")) {
                              return prev.filter(
                                (item) => item !== "terms_and_conditions"
                              );
                            } else {
                              return [...prev, "terms_and_conditions"];
                            }
                          })
                        }
                      >
                        <h4>Terms & Conditions</h4>
                        <svg
                          style={{
                            transform: openOuterAccordion.includes(
                              "terms_and_conditions"
                            )
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "0.3s ease-in-out",
                          }}
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_6802_2306"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                          >
                            <rect
                              y="24"
                              width="24"
                              height="24"
                              transform="rotate(-90 0 24)"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_6802_2306)">
                            <path
                              d="M11.9993 14.815L19.532 7.28227C19.7307 7.08361 19.9646 6.98677 20.2338 6.99177C20.5031 6.99694 20.7371 7.09885 20.9358 7.29752C21.1344 7.49635 21.2338 7.73035 21.2338 7.99952C21.2338 8.26869 21.1344 8.50269 20.9358 8.70152L13.28 16.3725C13.0992 16.5534 12.8966 16.6874 12.6723 16.7745C12.4479 16.8617 12.2236 16.9053 11.9993 16.9053C11.7749 16.9053 11.5506 16.8617 11.3263 16.7745C11.1019 16.6874 10.8994 16.5534 10.7185 16.3725L3.04728 8.70152C2.84862 8.50269 2.75187 8.26611 2.75703 7.99177C2.7622 7.71744 2.86412 7.48094 3.06278 7.28227C3.26145 7.08361 3.49545 6.98427 3.76478 6.98427C4.03395 6.98427 4.26787 7.08361 4.46653 7.28227L11.9993 14.815Z"
                              fill="#1C1B1F"
                            />
                          </g>
                        </svg>
                      </div>
                      {openOuterAccordion.includes("terms_and_conditions") && (
                        <div>
                          <div className={styles.policies_data}>
                            {singleActivityData?.activityLegals
                              ?.slice(2, 3)
                              .map((item, i) => (
                                <div className={styles.list_details} key={i}>
                                  <div
                                    className="w-full"
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                    {singleActivityData?.activityLegals?.filter(
                      (item) => item.type === "cancellation_policy"
                    )?.length > 0 && (
                    <div
                      className={styles.accord_heading}
                      id="cancellation_policy"
                    >
                      <div
                        className={styles.accord_flex}
                        onClick={() =>
                          setOpenOuterAccordion((prev) => {
                            if (prev.includes("cancellation_policy")) {
                              return prev.filter(
                                (item) => item !== "cancellation_policy"
                              );
                            } else {
                              return [...prev, "cancellation_policy"];
                            }
                          })
                        }
                      >
                        <h4>Cancellation Policy</h4>
                        <svg
                          style={{
                            transform: openOuterAccordion.includes(
                              "cancellation_policy"
                            )
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "0.3s ease-in-out",
                          }}
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_6802_2306"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                          >
                            <rect
                              y="24"
                              width="24"
                              height="24"
                              transform="rotate(-90 0 24)"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_6802_2306)">
                            <path
                              d="M11.9993 14.815L19.532 7.28227C19.7307 7.08361 19.9646 6.98677 20.2338 6.99177C20.5031 6.99694 20.7371 7.09885 20.9358 7.29752C21.1344 7.49635 21.2338 7.73035 21.2338 7.99952C21.2338 8.26869 21.1344 8.50269 20.9358 8.70152L13.28 16.3725C13.0992 16.5534 12.8966 16.6874 12.6723 16.7745C12.4479 16.8617 12.2236 16.9053 11.9993 16.9053C11.7749 16.9053 11.5506 16.8617 11.3263 16.7745C11.1019 16.6874 10.8994 16.5534 10.7185 16.3725L3.04728 8.70152C2.84862 8.50269 2.75187 8.26611 2.75703 7.99177C2.7622 7.71744 2.86412 7.48094 3.06278 7.28227C3.26145 7.08361 3.49545 6.98427 3.76478 6.98427C4.03395 6.98427 4.26787 7.08361 4.46653 7.28227L11.9993 14.815Z"
                              fill="#1C1B1F"
                            />
                          </g>
                        </svg>
                      </div>
                      {openOuterAccordion.includes("cancellation_policy") && (
                        <div>
                          <div className={styles.policies_data}>
                            {singleActivityData?.activityLegals
                              ?.slice(3, 4)
                              .map((item, i) => (
                                <div className={styles.list_details} key={i}>
                                  <div
                                    className="w-full"
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Points to Remember */}
                {singleActivityData?.activityLegals?.filter(
                      (item) => item.type === "points_to_remember"
                    )?.length > 0 && (
                    <div
                      className={styles.accord_heading}
                      id="points_to_remember"
                    >
                      <div
                        className={styles.accord_flex}
                        onClick={() =>
                          setOpenOuterAccordion((prev) => {
                            if (prev.includes("points_to_remember")) {
                              return prev.filter(
                                (item) => item !== "points_to_remember"
                              );
                            } else {
                              return [...prev, "points_to_remember"];
                            }
                          })
                        }
                      >
                        {" "}
                        <h4>Points to Remember</h4>{" "}
                        <svg
                          style={{
                            transform: openOuterAccordion.includes(
                              "points_to_remember"
                            )
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                            transition: "0.3s ease-in-out",
                          }}
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_6802_2306"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                          >
                            <rect
                              y="24"
                              width="24"
                              height="24"
                              transform="rotate(-90 0 24)"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_6802_2306)">
                            <path
                              d="M11.9993 14.815L19.532 7.28227C19.7307 7.08361 19.9646 6.98677 20.2338 6.99177C20.5031 6.99694 20.7371 7.09885 20.9358 7.29752C21.1344 7.49635 21.2338 7.73035 21.2338 7.99952C21.2338 8.26869 21.1344 8.50269 20.9358 8.70152L13.28 16.3725C13.0992 16.5534 12.8966 16.6874 12.6723 16.7745C12.4479 16.8617 12.2236 16.9053 11.9993 16.9053C11.7749 16.9053 11.5506 16.8617 11.3263 16.7745C11.1019 16.6874 10.8994 16.5534 10.7185 16.3725L3.04728 8.70152C2.84862 8.50269 2.75187 8.26611 2.75703 7.99177C2.7622 7.71744 2.86412 7.48094 3.06278 7.28227C3.26145 7.08361 3.49545 6.98427 3.76478 6.98427C4.03395 6.98427 4.26787 7.08361 4.46653 7.28227L11.9993 14.815Z"
                              fill="#1C1B1F"
                            />
                          </g>
                        </svg>
                      </div>
                      {openOuterAccordion.includes("points_to_remember") && (
                        <div className={styles.points_to_remember}>
                          <div className={styles.flex_data}>
                            {singleActivityData?.activityLegals
                              ?.slice(4, 5)
                              .map((item, i) => (
                                <div className={styles.list_details} key={i}>
                                  <div
                                    className="w-full"
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  />
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {singleActivityData?.activityFaqs?.length > 0 && (
                  <div className={styles.accord_heading} id="faq">
                    <div
                      className={styles.accord_flex}
                      onClick={() =>
                        setOpenOuterAccordion((prev) => {
                          if (prev.includes("faq")) {
                            return prev.filter((item) => item !== "faq");
                          } else {
                            return [...prev, "faq"];
                          }
                        })
                      }
                    >
                      <h4>FAQs</h4>
                      <svg
                        style={{
                          transform: openOuterAccordion.includes("faq")
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "0.3s ease-in-out",
                        }}
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_6802_2306"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect
                            y="24"
                            width="24"
                            height="24"
                            transform="rotate(-90 0 24)"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_6802_2306)">
                          <path
                            d="M11.9993 14.815L19.532 7.28227C19.7307 7.08361 19.9646 6.98677 20.2338 6.99177C20.5031 6.99694 20.7371 7.09885 20.9358 7.29752C21.1344 7.49635 21.2338 7.73035 21.2338 7.99952C21.2338 8.26869 21.1344 8.50269 20.9358 8.70152L13.28 16.3725C13.0992 16.5534 12.8966 16.6874 12.6723 16.7745C12.4479 16.8617 12.2236 16.9053 11.9993 16.9053C11.7749 16.9053 11.5506 16.8617 11.3263 16.7745C11.1019 16.6874 10.8994 16.5534 10.7185 16.3725L3.04728 8.70152C2.84862 8.50269 2.75187 8.26611 2.75703 7.99177C2.7622 7.71744 2.86412 7.48094 3.06278 7.28227C3.26145 7.08361 3.49545 6.98427 3.76478 6.98427C4.03395 6.98427 4.26787 7.08361 4.46653 7.28227L11.9993 14.815Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </svg>
                    </div>
                    {openOuterAccordion.includes("faq") &&
                      singleActivityData?.activityFaqs &&
                      singleActivityData?.activityFaqs.length > 0 && (
                        <div className={styles.accordion_sec}>
                          {singleActivityData?.activityFaqs?.map(
                            (item, index) => (
                              <div className={styles.accordion} key={index}>
                                <div
                                  className={styles.accordion_item}
                                  key={index}
                                >
                                  <div
                                    className="flex justify_content_between p_10 cursor_pointer accordion_icon align_items_center"
                                    onClick={() => toggleAccordion(index)}
                                  >
                                    <div className={styles.accordion_header}>
                                      {item?.question}
                                    </div>
                                    <div>
                                      {" "}
                                      <svg
                                        className={`accordion-icon ${
                                          activeIndex === index ? "rotated" : ""
                                        }`}
                                        width="13"
                                        height="13"
                                        viewBox="0 0 9 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.25 0.75L4.75 4.25L1.25 0.75"
                                          stroke="#000"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                  <div
                                    className={`accordion-item-body ${
                                      activeIndex === index ? "active" : ""
                                    }`}
                                  >
                                    <div
                                      className={styles.accordion_item_content}
                                      dangerouslySetInnerHTML={{
                                        __html: item?.answer,
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      )}
                  </div>
                )}
              </div>

              <aside>
                <div id={styles.price_sticky}>
                  <div
                    className={styles.common_bg}
                    style={{
                      backgroundColor: openTabs.includes("addons")
                        ? "#FFFCF3"
                        : "#fff",
                      borderBottom: "0",
                    }}
                  >
                    <div
                      className="flex align_items_center justify_content_between pointer"
                      onClick={() => toggleTab("addons")}
                    >
                      {" "}
                      <h4 style={{ fontWeight: "600" }}>Add Ons</h4>
                      <svg
                        style={{
                          transform: openTabs.includes("addons")
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "0.3s ease-in-out",
                        }}
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_6802_2306"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="15"
                          height="15"
                        >
                          <rect
                            y="24"
                            width="24"
                            height="24"
                            transform="rotate(-90 0 24)"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_6802_2306)">
                          <path
                            d="M11.9993 14.815L19.532 7.28227C19.7307 7.08361 19.9646 6.98677 20.2338 6.99177C20.5031 6.99694 20.7371 7.09885 20.9358 7.29752C21.1344 7.49635 21.2338 7.73035 21.2338 7.99952C21.2338 8.26869 21.1344 8.50269 20.9358 8.70152L13.28 16.3725C13.0992 16.5534 12.8966 16.6874 12.6723 16.7745C12.4479 16.8617 12.2236 16.9053 11.9993 16.9053C11.7749 16.9053 11.5506 16.8617 11.3263 16.7745C11.1019 16.6874 10.8994 16.5534 10.7185 16.3725L3.04728 8.70152C2.84862 8.50269 2.75187 8.26611 2.75703 7.99177C2.7622 7.71744 2.86412 7.48094 3.06278 7.28227C3.26145 7.08361 3.49545 6.98427 3.76478 6.98427C4.03395 6.98427 4.26787 7.08361 4.46653 7.28227L11.9993 14.815Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </svg>
                    </div>

                    {openTabs.includes("addons") &&
                      singleActivityData?.additionalAddons &&
                      singleActivityData?.additionalAddons.length > 0 && (
                        <div>
                          {singleActivityData.additionalAddons.map(
                            (item, index) => {
                              let finalAddonPrice = item?.price;
                              let addonPriceWithMarkup = item?.price;

                              if (markupData) {
                                const markup = markupData;
                                if (markup.markupType === "percentage") {
                                  finalAddonPrice +=
                                    (item.price * parseFloat(markup.amount)) /
                                    100;
                                } else if (markup.markupType === "fixed") {
                                  finalAddonPrice += parseFloat(markup.amount);
                                }
                              }
                              addonPriceWithMarkup = finalAddonPrice;

                              if (
                                commission?.commissionAmount &&
                                commission?.commissionType
                              ) {
                                if (
                                  commission?.commissionType === "percentage"
                                ) {
                                  finalAddonPrice -=
                                    (Number(finalAddonPrice) *
                                      Number(commission?.commissionAmount)) /
                                    100;
                                } else if (
                                  commission?.commissionType === "fixed"
                                ) {
                                  finalAddonPrice = Number(
                                    commission?.commissionAmount
                                  );
                                }
                              }

                              return (
                                <div
                                  key={index}
                                  className="flex justify_content_between w-100 mt-10 align_items_center  p_10"
                                  style={{
                                    backgroundColor: selectedAddOns?.some(
                                      (discount) => discount.id === item.id
                                    )
                                      ? "#E8F9F1"
                                      : "#FFFFFF",
                                    border: selectedAddOns?.some(
                                      (discount) => discount.id === item.id
                                    )
                                      ? "none"
                                      : "1px solid #ccc",
                                    color: selectedAddOns?.some(
                                      (discount) => discount.id === item.id
                                    )
                                      ? "#009A50"
                                      : "#333",
                                  }}
                                >
                                  <div style={{ textTransform: "capitalize" }}>
                                    <div
                                      style={{
                                        cursor: "pointer",
                                        width: "100%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: 500,
                                        }}
                                      >
                                        {item.detail}{" "}
                                        {commission?.commissionAmount &&
                                          commission?.commissionType && (
                                            <span
                                              style={{
                                                fontSize: "12px",
                                                color: "red",
                                                textDecoration: "line-through",
                                              }}
                                            >
                                              {formatIndianCurrency(
                                                addonPriceWithMarkup
                                              )}
                                            </span>
                                          )}{" "}
                                        <span
                                          style={{
                                            fontSize: "12px",
                                          }}
                                        >
                                          {formatIndianCurrency(
                                            finalAddonPrice
                                          )}{" "}
                                          {item.perPerson
                                            ? `* ${bookingData?.adult}`
                                            : ""}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="flex justify_content_end"
                                    style={{ width: "60%" }}
                                  >
                                    <button
                                      style={{ fontSize: "10px" }}
                                      onClick={() =>
                                        handleSelectedAddOns({
                                          ...item,
                                          finalAddonPrice,
                                          addonPriceWithMarkup,
                                        })
                                      }
                                    >
                                      {selectedAddOns.some(
                                        (addon) => addon.id === item.id
                                      ) ? (
                                        <div style={{ color: "red" }}>
                                          <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <rect
                                              x="0.5"
                                              y="0.5"
                                              width="19"
                                              height="19"
                                              stroke="#333333"
                                            />
                                            <mask
                                              id="mask0_6072_17467"
                                              style={{ maskType: "alpha" }}
                                              maskUnits="userSpaceOnUse"
                                              x="2"
                                              y="2"
                                              width="16"
                                              height="16"
                                            >
                                              <rect
                                                x="2.5"
                                                y="2.5"
                                                width="15"
                                                height="15"
                                                fill="#D9D9D9"
                                              />
                                            </mask>
                                            <g mask="url(#mask0_6072_17467)">
                                              <path
                                                d="M6.50039 14.1585L5.8418 13.4999L9.3418 9.9999L5.8418 6.4999L6.50039 5.84131L10.0004 9.34131L13.5004 5.84131L14.159 6.4999L10.659 9.9999L14.159 13.4999L13.5004 14.1585L10.0004 10.6585L6.50039 14.1585Z"
                                                fill="#333333"
                                              />
                                            </g>
                                          </svg>
                                        </div>
                                      ) : (
                                        <div
                                          style={{
                                            background: "#009A50",
                                            color: "#fff",
                                            padding: "4px 6px",
                                            display: "flex",
                                            textTransform: "uppercase",
                                            fontSize: "12px",
                                            fontWeight: "600",
                                          }}
                                        >
                                          {" "}
                                          Add
                                        </div>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      )}
                  </div>
                  <div
                    className={styles.common_bg}
                    style={{
                      backgroundColor: openTabs.includes("priceBreakup")
                        ? "#FFFCF3"
                        : "#fff",
                    }}
                  >
                    <div
                      className="flex align_items_center justify_content_between pointer"
                      onClick={() => toggleTab("priceBreakup")}
                    >
                      {" "}
                      <h4 style={{ fontWeight: "600" }}>Price Breakup</h4>
                      <svg
                        style={{
                          transform: openTabs.includes("priceBreakup")
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "0.3s ease-in-out",
                        }}
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_6802_2306"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="15"
                          height="15"
                        >
                          <rect
                            y="24"
                            width="24"
                            height="24"
                            transform="rotate(-90 0 24)"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_6802_2306)">
                          <path
                            d="M11.9993 14.815L19.532 7.28227C19.7307 7.08361 19.9646 6.98677 20.2338 6.99177C20.5031 6.99694 20.7371 7.09885 20.9358 7.29752C21.1344 7.49635 21.2338 7.73035 21.2338 7.99952C21.2338 8.26869 21.1344 8.50269 20.9358 8.70152L13.28 16.3725C13.0992 16.5534 12.8966 16.6874 12.6723 16.7745C12.4479 16.8617 12.2236 16.9053 11.9993 16.9053C11.7749 16.9053 11.5506 16.8617 11.3263 16.7745C11.1019 16.6874 10.8994 16.5534 10.7185 16.3725L3.04728 8.70152C2.84862 8.50269 2.75187 8.26611 2.75703 7.99177C2.7622 7.71744 2.86412 7.48094 3.06278 7.28227C3.26145 7.08361 3.49545 6.98427 3.76478 6.98427C4.03395 6.98427 4.26787 7.08361 4.46653 7.28227L11.9993 14.815Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </svg>
                    </div>
                    {openTabs.includes("priceBreakup") && (
                      <>
                        {commission && Object.keys(commission).length > 0 && (
                          <div className="flex justify_content_between mt-10">
                            <p>Commission</p>
                            <span className="room_text-right">
                              {commission.commissionType === "fixed" ? (
                                <span className="room_text-right">
                                  {formatIndianCurrency(
                                    commission?.commissionAmount
                                  )}
                                </span>
                              ) : (
                                <span className="room_text-right">
                                  {commission?.commissionAmount}%
                                </span>
                              )}
                            </span>
                          </div>
                        )}

                        {displayedRate !== null ? (
                          <>
                            <div className="flex justify_content_between mt-10">
                              <div>Starting Price</div>
                              <span
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "end",
                                }}
                              >
                                {commission &&
                                  Object.keys(commission).length > 0 && (
                                    <small
                                      style={{
                                        color: "red",
                                        textDecoration: "line-through",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {/* {formatIndianCurrency(calculatePriceWithCommission(displayedRate, commission))} */}
                                      {formatIndianCurrency(displayedRate)}
                                    </small>
                                  )}
                                <b>
                                  {displayedRate !== null
                                    ? formatIndianCurrency(
                                        calculatePriceWithCommission(
                                          displayedRate,
                                          commission
                                        )
                                      )
                                    : "Rate not available, please update adults"}{" "}
                                </b>
                                <small>per Adult</small>
                              </span>
                            </div>
                          </>
                        ) : (
                          <p> Rate not available, please modify adults</p>
                        )}

                        {selectedAddOns && selectedAddOns.length > 0 && (
                          <>
                            <div className="flex justify_content_between mt-10">
                              <p>Addons Price</p>
                              <span
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "end",
                                }}
                              >
                                {commission &&
                                  Object.keys(commission).length > 0 && (
                                    <small
                                      style={{
                                        color: "red",
                                        textDecoration: "line-through",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {formatIndianCurrency(
                                        totalAddonsCostWithoutCommission
                                      )}
                                    </small>
                                  )}
                                <b>{formatIndianCurrency(totalAddonsCost)}</b>
                              </span>
                            </div>
                          </>
                        )}

                        <div>
                          {displayedRate && displayedRate !== null && (
                            <button
                              style={{ marginTop: "10px" }}
                              className={styles.book_btn}
                              onClick={navigateToCheckOutActivity}
                            >
                              Book Now
                            </button>
                          )}
                          <button
                            className={styles.send_btn}
                            onClick={(e) => handleshowRatePopup(e)}
                          >
                            Send Enquiry
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                <div className={styles.query}>
                  {" "}
                  <div className={styles.common_bg}>
                    <h4>Have A Question</h4>
                    <p>
                      Our Destination expert will be happy to help you resolve
                      your queries for this tour.
                    </p>
                    <div>
                      {" "}
                      <div className="mt-10">
                        {" "}
                        <a href="tel:+919805021966">
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.23 15.26L16.69 14.97C16.3914 14.9349 16.0886 14.968 15.8046 15.0667C15.5206 15.1654 15.2626 15.3273 15.05 15.54L13.21 17.38C10.3712 15.9362 8.06382 13.6288 6.62004 10.79L8.47004 8.94001C8.90004 8.51001 9.11004 7.91001 9.04004 7.30001L8.75004 4.78001C8.69335 4.29219 8.45923 3.84225 8.09228 3.51586C7.72532 3.18947 7.25115 3.00943 6.76004 3.01001H5.03004C3.90004 3.01001 2.96004 3.95001 3.03004 5.08001C3.56004 13.62 10.39 20.44 18.92 20.97C20.05 21.04 20.99 20.1 20.99 18.97V17.24C21 16.23 20.24 15.38 19.23 15.26Z"
                              fill="#EB442D"
                            />
                          </svg>
                          +91-98050-21966
                        </a>
                      </div>
                      <div className="mt-10">
                        {" "}
                        <a href="mailto:info@mountainmysteries.com">
                          <svg
                            width="22"
                            height="22"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_6072_17501"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="16"
                              height="16"
                            >
                              <rect width="16" height="16" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_6072_17501)">
                              <path
                                d="M2.87216 13C2.53538 13 2.25033 12.8833 2.01699 12.65C1.78366 12.4167 1.66699 12.1316 1.66699 11.7948V4.20517C1.66699 3.86839 1.78366 3.58333 2.01699 3.35C2.25033 3.11667 2.53538 3 2.87216 3H13.1285C13.4653 3 13.7503 3.11667 13.9837 3.35C14.217 3.58333 14.3337 3.86839 14.3337 4.20517V11.7948C14.3337 12.1316 14.217 12.4167 13.9837 12.65C13.7503 12.8833 13.4653 13 13.1285 13H2.87216ZM8.00033 8.37183L13.3337 4.9615L13.2312 4L8.00033 7.33333L2.76949 4L2.66699 4.9615L8.00033 8.37183Z"
                                fill="#EB442D"
                              />
                            </g>
                          </svg>
                          info@mountainmysteries.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </div>

          {showRatePopup && (
            <ActivityQueryFormPopup
              package_id={singleActivityData?.id}
              setshowRatePopup={setshowRatePopup}
              typeDetail="activity"
              activityDestination={singleActivityData?.activityDestination}
              singleActivityData={singleActivityData}
            />
          )}
        </section>
      </div>
      <div className={styles.footer_bottom_align}>
        <NewFooterUI />
      </div>
      <div className={styles.mobile_price_breakup}>
        <div className="">
          <div>Activity Amt.</div>
          {commission && Object.keys(commission).length > 0 && (
            <small
              style={{
                color: "red",
                textDecoration: "line-through",
                fontSize: "12px",
              }}
            >
              {/* {formatIndianCurrency(calculatePriceWithCommission(displayedRate, commission))} */}
              {formatIndianCurrency(displayedRate)}
            </small>
          )}
          <b>
            {displayedRate !== null
              ? formatIndianCurrency(
                  calculatePriceWithCommission(displayedRate, commission)
                )
              : "Rate not available, please update adults"}{" "}
          </b>
          <small>per Adult</small>
        </div>
        {displayedRate && displayedRate !== null && (
          <button
            className={styles.book_btn}
            onClick={navigateToCheckOutActivity}
          >
            Continue
          </button>
        )}
      </div>
    </div>
  );
}

export default SingleActivity;
